import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { createSession, SessioneUtente } from './utente-sessione.model';

export interface SessioneUtenteState {
  utente: SessioneUtente;
}

export function createInitialState(): SessioneUtenteState {
  return {
    utente: null
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'utenteSessione', idKey: 'email' })
export class SessioneUtenteStore extends Store<SessioneUtenteState> {
  constructor() {
    super(createInitialState());
  }
  login(data: SessioneUtente) {
    const user = createSession(data);
    this.update({ utente: user });
  }

  logout() {
    this.update(createInitialState());
  }
}
